import { Button, RemovableTag } from '@monash/portal-react';
import { useState } from 'react';
import FiltersModal from './filters-modal/FiltersModal';
import { useFieldArray } from 'react-hook-form';
import c from './filters.module.scss';
import { LINKS_FILTER_FULL_TEXT } from './constants';

const Filters = ({ disabled }) => {
  const [showFiltersModal, setShowFiltersModal] = useState(false);

  const {
    fields: filtersFields,
    append: appendFilter,
    remove: removeFilter,
  } = useFieldArray({
    name: 'filters',
  });

  return (
    <div className={c.container}>
      {filtersFields.length > 0 && (
        <div className={c.filterPills}>
          {filtersFields.map(({ value, id }, i) => {
            return (
              <RemovableTag
                key={id}
                text={LINKS_FILTER_FULL_TEXT[value]}
                onRemove={() => {
                  removeFilter(i);
                }}
                size="large"
                color="greyBlue"
                disabled={disabled}
              />
            );
          })}
        </div>
      )}
      <Button
        variant="text"
        mode="card"
        size="small"
        onClick={() => setShowFiltersModal(true)}
        className={c.addButton}
        disabled={disabled}
      >
        Add filter
      </Button>
      <FiltersModal
        open={showFiltersModal}
        onClose={() => setShowFiltersModal(false)}
        filtersFields={filtersFields}
        appendFilter={appendFilter}
        removeFilter={removeFilter}
      />
    </div>
  );
};

export default Filters;
